import React, { useState, useEffect } from 'react'
import './EstimateBillRonak.css'

function EstimateBillRonak() {
  const [billData, setBillData] = useState(null)
  const [headerData, setHeaderData] = useState(null)
  const [lineData, setLineData] = useState([])

  useEffect(() => {
    // Fetch data from session storage
    const sessionData = sessionStorage.getItem('BillEstimateData')
    if (sessionData) {
      const parsedData = JSON.parse(sessionData)
      setBillData(parsedData)
      setHeaderData(parsedData.BillEstimateHData?.[0] || null)
      setLineData(parsedData.BillEstimateLData || [])
      
      console.log(parsedData.BillEstimateLData )
             // Auto-print after data is loaded and rendered
       setTimeout(() => {
         handlePrint()
       }, 3000) // Wait 3 seconds for data to render properly
    }
  }, [])

  const handlePrint = () => {
    // Print directly without opening new tab
    window.print()
  }

  const formatCurrency = (amount) => {
    return parseFloat(amount).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  // Check if UC and Disc columns should be shown
  const shouldShowUC = lineData.some(item => parseFloat(item.UC) != 0)
  const shouldShowDisc = lineData.some(item => parseFloat(item.Disc) != 0)

  if (!billData) {
    return <div className="loading">Loading estimate data...</div>
  }

  return (
    <div className="page-content">
      <div className="estimate-bill-container">
        {/* Print Button */}
        <div className="print-button-container">
          <button onClick={handlePrint} className="print-btn">
            Print Estimate
          </button>
        </div>

        {/* Estimate Bill Content */}
        <div className="estimate-bill" id="printSection">
        {/* Header Section */}
        <div className="bill-header">
          <div className="header-estimate-no">
            <div className="estimate-no">
              ESTIMATE NO : {headerData?.VoucherNo || 'N/A'}
            </div>
          </div>
          <div className="header-customer-name">
            <div className="customer-name">
              Name : {headerData?.Name || 'N/A'}
            </div>
          </div>
          <div className="header-mobile">
            <div className="mobile-field">
              Mobile : {headerData?.Mobile || ''}
            </div>
          </div>
          <div className="header-date">
            <div className="date-field">
              Date : {headerData?.VoucherDate || 'N/A'}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bill-table">
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Item Name</th>
                <th>Colour</th>
                <th>Qty</th>
                <th>MRP</th>
                {shouldShowUC && <th>UC</th>}
                <th>NET PRICE</th>
                {shouldShowDisc && <th>Disc</th>}
                <th>NET</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {lineData.map((item, index) => (
                <tr key={index}>
                  <td>{item.CodeNo}</td>
                  <td>{item.ItemTypeName}</td>
                  <td>{item.ColorQty}</td>
                  <td>{item.TotalQty}</td>
                  <td>{item.Rate}</td>
                  {shouldShowUC && <td>{item.UC}</td>}
                  <td>{item.NetPrice}</td>
                  {shouldShowDisc && <td>{item.Disc}</td>}
                  <td>{item.FinalRate}</td>
                  <td>{item.Amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Section */}
        <div className="bill-footer">
          <div className="footer-left">
            <div className="transport-name">
              Trp Name : {headerData?.TrpName || 'N/A'}
            </div>
          </div>
          <div className="footer-center">
            <div className="parcel-info">
              Parcel : {headerData?.Remarks || 'N/A'}
            </div>
          </div>
          <div className="footer-signatory">
            <div className="signatory">
              Signatory: {headerData?.Signatory || 'N/A'}
            </div>
          </div>
          <div className="footer-right">
            <div className="total-amount">
              Total : {formatCurrency(headerData?.NetAmount || 0)}
            </div>
          </div>
        
        </div>
        </div>
      </div>
    </div>
  )
}

export default EstimateBillRonak